import React from 'react';
import ReputationBenchmarking from './ReputationBenchmarking';

const Reputation = () => {
  return <ReputationBenchmarking />;
};

export default Reputation;